import "./Branches.css";
import { MapPin, Mail, Phone } from "lucide-react";
import { useEffect, useState } from "react";
import api from "../lib/api";

const branches = [
  {
    name: "Dubai Branch",
    address: "Deira, Dubai, UAE",
    email: "admin@mariotkitchen.com",
    phone: "+971 4 288 2777",
    map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14431.906351691736!2d55.333482!3d25.271373!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5cc11a3decb1%3A0xcbf6f96b27d47ed0!2z2YXYp9ix2YrZiNiqINmE2YXYudiv2KfYqiDYp9mE2YXYt9in2KjYriB8IE1hcmlvdCBLaXRjaGVuIEVxdWlwbWVudA!5e0!3m2!1sen!2sus!4v1784732080786!5m2!1sen!2sus"
  },
  {
    name: "Al Ain Branch",
    address: "Al Ain Industrial Area, UAE",
    email: "alain@mariotkitchen.com",
    phone: "+971 3 722 7337",
    map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14558.690440569799!2d55.762647!3d24.183212!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8ab7f023fc95a5%3A0xc42649fb40dab407!2sMariot%20Kitchen%20Equipment!5e0!3m2!1sen!2sus!4v1784732114296!5m2!1sen!2sus"
  },
  {
    name: "Abu Dhabi Muroor Branch",
    address: "Muroor Road, Abu Dhabi, UAE",
    email: "sales2@mariotkitchen.com",
    phone: "+971 2 645 9353",
    map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7261.004526182325!2d54.374451!3d24.502697!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e66f6711522f7%3A0xba8c40636e4d1dc1!2sMariot%20Kitchen%20Equip!5e0!3m2!1sen!2sus!4v1784732180517!5m2!1sen!2sus"
  },
  {
    name: "Sharjah Branch",
    address: "Al Majaz, Sharjah, UAE",
    email: "sales@mariot-group.com",
    phone: "+971 6 767 7777",
    map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7213.2498989855085!2d55.382416!3d25.316802!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5b111a48b363%3A0xf594b5fad15d22af!2z2YXYp9ix2YrZiNiqINmE2YXYudiv2KfYqiDYp9mE2YXYt9in2KjYriB8IE1hcmlvdCBLaXRjaGVuIEVxdWlwbWVudA!5e0!3m2!1sen!2sus!4v1784732195077!5m2!1sen!2sus"
  },
  {
    name: "Sharjah Industrial Branch",
    address: "Industrial Area, Sharjah, UAE",
    email: "factory@mariotkitchen.com",
    phone: "+971 6 767 7776",
    map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7214.680620003732!2d55.429508!3d25.292768!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5f1068f8c01d%3A0xfa273e3af48feb67!2z2YXYp9ix2YrZiNiqINmE2YXYudiv2KfYqiDYp9mE2YXYt9in2KjYriDYp9mE2LTYp9ix2YLYqSB8IE1hcmlvdCBLaXRjaGVuIEVxdWlwbWVudA!5e0!3m2!1sen!2sus!4v1784732215386!5m2!1sen!2sus"
  }
];

export default function Branches() {
  const [branchItems, setBranchItems] = useState(branches);

  useEffect(() => {
    api.get("/branches").then((response) => {
      if (Array.isArray(response.data) && response.data.length > 0) setBranchItems(response.data);
    }).catch(() => {});
  }, []);

  return (
    <div className="branches-page">

      <section className="branches-hero">
        <div className="container">
          <h1>Our Branches</h1>

          <p>
            Mariot Kitchen Equipment proudly serves customers across the UAE
            through strategically located branches. Whether you are planning a
            new restaurant, hotel, bakery, supermarket, café, or commercial
            kitchen, our experienced team is ready to provide expert guidance,
            premium equipment, installation services, and reliable after-sales
            support.
          </p>

          <p>
            Visit your nearest Mariot showroom to explore our complete range of
            commercial kitchen equipment from world-renowned brands and discuss
            your project with our specialists.
          </p>
        </div>
      </section>

      <section className="branches-section">
        <div className="container">

          <div className="branches-grid">

            {branchItems.map((branch, index) => {
              const name = branch.name_en || branch.name;
              const address = branch.address_en || branch.address;
              const phone = branch.phones?.find(Boolean) || branch.phone;
              const map = branch.map_embed || branch.map || branch.map_url;
              return (
              <div className="branch-card" key={index}>

                <div className="branch-content">

                  <h2>{name}</h2>

                  <div className="branch-info">

                    <div className="info-row">
                      <MapPin size={18} />
                      <span>{address}</span>
                    </div>

                    <div className="info-row">
                      <Mail size={18} />
                      <a href={`mailto:${branch.email}`}>
                        {branch.email}
                      </a>
                    </div>

                    <div className="info-row">
                      <Phone size={18} />
                      <a href={`tel:${phone}`}>
                        {phone}
                      </a>
                    </div>

                  </div>

                </div>

                <div className="branch-map">
                  <iframe
                    src={map}
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="strict-origin-when-cross-origin"
                    title={name}
                  />
                </div>

              </div>
            )})}

          </div>

        </div>
      </section>

      <section className="branches-bottom">
        <div className="container">

          <h2>Why Visit a Mariot Branch?</h2>

          <p>
            Our branches provide product demonstrations, project consultation,
            equipment recommendations, installation planning, and technical
            support. Whether you are upgrading an existing kitchen or launching
            a new hospitality project, our experts are available to help you
            select the ideal commercial kitchen solutions for your business.
          </p>

        </div>
      </section>

    </div>
  );
}
